<div class="tools__trigger" (click)="toolsTrigger()" [ngClass]="active ? 'active' : ''"></div>
<div class="tools">
    <div class="tools__container" [ngClass]="active ? 'active' : ''">
        <div class="row">
            <div class="row__item">
                <div class="createNavAid" (click)="footerTrigger()"></div>
            </div>
            <div class="row__item">
                <div class="editNavAid" (click)="footerEditNavaidTrigger()"></div>
            </div>
            <div class="row__item">
                <div class="deleteNavAid" (click)="deleteNavaids()"></div>
            </div>
        </div>

          <div class="row">
              <div class="row__item">
                  <div class="createCP" (click)="coordinatePointTrigger()"></div>
              </div>
              <div class="row__item">
                  <div class="editCP" (click)="editCoordinatePointTrigger()"></div>
              </div>
              <div class="row__item">
                  <div class="deleteCP" (click)="deleteCoordinatePoints()"></div>
              </div>
          </div>
    </div>
</div>
